
export const clientUrls = {
    home: '/',
    login: '/',
    newPatient: '/patient/new',
    editPatient: '/patient/edit/:id',
    viewPatient: '/patient/view',
    changePass: '/changepass'
};

export const makeUrl = (url, from, to) => {
    return url.replace(':'+from, to);
}

export const serverUrls = {
    patient: '/api/patient/',
    pageCount: '/api/pagecount/',
    performaone: '/api/performaone/',
    clinicalFeature: '/api/clinicalfeature/',
    investigation: '/api/investigation/',
    dexa: '/api/dexa/',
    dexa1: '/api/dexa1/',
    dexa3: '/api/dexa3/',
    scans: '/api/scans/',
    xray: '/api/xray/',
    disorderandtreatment: '/api/disorderandtreatment/',
    user: '/adminapp/api/user/',
    login: '/adminapp/api/login/',
    logout: '/adminapp/api/logout/',
    changePassword: '/adminapp/api/updateuser/',
    upload: '/upload/',
    getData: '/api/getdata?id=:id',
    getCsv: '/api/getcsv',
    hrpqct: '/api/hrpqct/'
};